import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'
import { cleanFilters } from './tools'

const DEFAULT_SEARCHES = ['legendary 250+', 'shotgun 100-200', 'vault', 'void power', 'common legs', 'rare modifications 1-2 characters', 'rare modifications 3+ vault']

const state = {
  searches: JSON.parse(localStorage.getItem('searches') || 'false') || DEFAULT_SEARCHES,
  variousLabels: ['Duplicated', 'Different', 'Favorited', 'Unfavorited', 'Equipped', 'Unequipped', 'Transferable', 'Untransferable', 'Best duplicates', 'Worst duplicates'],
  ordering: 'Default'
}

cleanFilters(state)

const store = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default store



// WEBPACK FOOTER //
// ./src/store/destiny/filters/index.js